module.exports = __webpack_public_path__ + "static/media/empretec-4.0fcfc2c6.jpg";